import Vue from 'vue'
import Antd from 'ant-design-vue'
import Viser from 'viser-vue'
// import '@/mock'
import 'animate.css/source/animate.css'
import Plugins from '@/plugins'
import { initI18n } from '@/utils/i18n'
import bootstrap from '@/bootstrap'
import ButtonPermission from '@/constants/buttonPermission'
import auth from '@/directive/authDirective'
import { Row, Col, Image, FormItem, Tree, Input, Radio, Select, Option, Tooltip, Icon, Form, RadioGroup, CheckboxGroup, Checkbox, Cascader, Table, TableColumn, Loading, Dialog, InputNumber, InfiniteScroll, Collapse, CollapseItem } from 'element-ui';
import Logger from '@thales/logger'
import Track from '@thales/track';
import { useSentry } from "@/utils/addSentry";
import VueCompositionAPI from '@vue/composition-api';
import Viewer from 'v-viewer';
import env from '../env/index';
import App from './App.vue'
import store from './store'
import { router } from './router'
import './filters/formatTimestamp'
import './theme/index.less'
import './theme/index.css'
import 'element-ui/lib/theme-chalk/index.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'viewerjs/dist/viewer.min.css';
// eslint-disable-next-line import/order
import { useSubWujie } from "@/utils/subWujie";

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 99999,
  },
});
const i18n = initI18n('CN', 'US')
useSentry(Vue, router)

Track.init({
  domainId: 'CUSTOMER',
  appName: '运荔枝货主版',
  env: process.env.VUE_APP_ENV,
}, Vue, router)

Vue.use(Antd)
Vue.config.productionTip = false
Vue.use(Viser)
Vue.use(Plugins)
Vue.use(Row)
Vue.use(Col)
Vue.use(Image)
Vue.use(FormItem)
Vue.use(Tree)
Vue.use(Input)
Vue.use(Radio)
Vue.use(Tooltip)
Vue.use(RadioGroup)
Vue.use(Form)
Vue.use(Icon)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Cascader)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(InputNumber)
Vue.use(Select)
Vue.use(Option)
Vue.use(InfiniteScroll)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.prototype.$_ButtonPermission = ButtonPermission

const loggerConfig = env.LOGGER_CONFIG
const user = JSON.parse(localStorage.getItem('vuex'))
const { account, accountId, customerCode, customerId, userId, userName } = user?.user || {}
// 注册Logger
Vue.use(Logger, loggerConfig.sentryDsn, {
  release: loggerConfig.release,
  enable: loggerConfig.enable,
  getUserinfo: () => {
    return {
      account,
      accountId,
      customerCode,
      customerId,
      userId,
      userName,
    }
  }
})


bootstrap({ router, store, i18n, message: Vue.prototype.$message })
auth()

// 引入VueCompositionAPI
Vue.use(VueCompositionAPI);

// eslint-disable-next-line no-underscore-dangle
if (window.__POWERED_BY_WUJIE__) {
  // const { AMap, AMapUI, Loca } = window.parent;
  // window.AMap = AMap;
  // window.AMapUI = AMapUI;
  // window.Loca = Loca;
  // console.log('进入无界应用', window, window.parent);
  useSubWujie();
  // eslint-disable-next-line no-undef
  $wujie.bus.$emit('SUB_APP_LOADED');
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
